<template>
  <section class="smart1-page-wrapper">
    <div class="content-box">
      <h3 class="title font1-4">轻盈灵动的 Smartbar</h3>
      <h3 class="title font2-4">保留最大的视觉净空区</h3>
      <h3 class="title font3-4">四角拖动 意动随心</h3>

      <m-video
        class="end_video"
        poster="@/auto/assets/video/4/bg_1.5x.png"
        src="@/auto/assets/video/4/smart1.mp4"
        width="100%"
        muted
        loop
        ref="end_video"
        @timeupdate="timeupdate($event)"
      ></m-video>
    </div>
    <div class="seat"></div>
  </section>
</template>

<script>
import { videoPlayByVisibleArea } from '@/utils'

export default {
  name: 'ToBeEnd_Aircondition',
  data() {
    return {
      tl: '',
      thisTime: false,
    }
  },
  watch: {
    thisTime(val) {
      if (val == 0) {
        this.tl.to('.font1-4', { opacity: 1, delay: 0.5, duration: 0.75 })
        this.tl.to('.font1-4', { opacity: 0, duration: 0.75 }, '+=1.25')
        this.tl.from('.font1-4', { opacity: 0 })
      }
      if (val == 2) {
        this.tl.to('.font2-4', { opacity: 1, delay: 0.75, duration: 0.75 })
        this.tl.to('.font2-4', { opacity: 0, duration: 0.75 }, '+=2')
        this.tl.from('.font2-4', { opacity: 0 })
      }
      if (val == 3) {
        this.tl.to('.font3-4', { opacity: 1, delay: 1, duration: 0.75 })
        this.tl.to('.font3-4', { opacity: 0, duration: 0.75 }, '+=6.5')
        this.tl.from('.font3-4', { opacity: 0 })
      }
    },
  },
  methods: {
    timeupdate(e) {
      // 视频大约10.39s
      const currentTime = e.target.currentTime
      // 第三个标题
      if (currentTime >= 3) {
        this.thisTime = 3
        return
      }
      // 第二个标题
      if (currentTime >= 2) {
        this.thisTime = 2
        return
      }
      // 第一个标题展示
      if (currentTime >= 0) {
        this.thisTime = 0
        return
      }
    },
    videoRunner() {
      const end_video = this.$refs.end_video
      end_video && videoPlayByVisibleArea(end_video)
    },
    // pagePin() {
    //   this.$gsap.timeline({
    //     scrollTrigger: {
    //       trigger: '.smart1-page-wrapper',
    //       end: '+4000',
    //       pin: true,
    //     },
    //   })
    // },
    onPreload() {
      // this.pagePin()
      this.tl = this.$gsap.timeline({})
      this.videoRunner()
    },
  },
}
</script>

<style lang="less" scoped>
// 占位
.seat {
  height: 3000px;
  width: 100%;
}
.smart1-page-wrapper {
  position: relative;
  // height: 100vh;
  background: #17181c;
  overflow: hidden;
  position: sticky;
  top: 0;

  .content-box {
    margin: auto;
    position: relative;
  }
  .title {
    opacity: 0;
    margin: 0;
    top: 12.4%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    color: #fff;
    text-align: center;
    font-family: Flyme Sans VF;
    font-size: 64px;
    font-style: normal;
    font-weight: 700;
    line-height: 82px; /* 128.125% */
    letter-spacing: 3.84px;
  }
  .end_video {
    // border: 10px solid #000000;
    // border-radius: 12px;
    // margin-top: -300px;
    overflow: hidden;
  }
}
</style>
